<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lLqVOX/Images/cover.jpg?1685327426136" alt="This image is the cover for the book Mission Mistletoe, 2015 Advent Calendar - Sleigh Ride"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mission Mistletoe, 2015 Advent Calendar - Sleigh Ride
      </h1>
      <p class="bookDescription body article font2">
        <p>Captain Archer Pfeil’s current assignment has been nothing but one long string of disasters. As if being dumped right before Christmas wasn’t enough, the mounting misfortunes indicate he’ll be out of a job by the end of his mission.</p> <p>But it’s difficult to salvage the assignment with Ambassador Ilin a'dlen Jhex around, pushing all Archer’s buttons. He struggles to keep his distance from the out-of-bounds ambassador, but Jhex has other plans in mind….</p><p><i>A story from the Dreamspinner Press 2015 Advent Calendar package "Sleigh Ride".</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jessica Payseur
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a4c09ea2